import React from 'react';
import './Overlay.scss'

export const Overlay = ({
    show,
    label
}) => (
    <div className={["ds-app-overlay", (show === true ? 'dsao-show' : '')].join(' ')}>
        <div className="dsao-content">
            <div className="loader"></div>
            {label ? <div className="text-muted mt-4">{label}</div> : null}
        </div>
    </div>
);

export default Overlay;